import { useScrmFetch } from "@/hooks/common/fetch/useFetch";

// Zendesk联系表单提交接口
export const useZendeskContactApi = async (params = {}) => {
	
	return await useScrmFetch(`/api/gws-ext/zendesk/contact`).post({
        ...params,
	  }).json();
}